import { I18nProvider } from './i18n';
import MainScreen from './ui/MainScreen';

export default function App() {
  return (
    <I18nProvider>
      <MainScreen />
    </I18nProvider>
  );
}
